import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const usePatientFamilyMedicalHistory = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientMedicalFamilyHistory", patientId],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientfamilyhistory/getbypatientid/${patientId}`
      );
      return response?.data;
    },
    enabled: !!tenantVal && !!patientId,
  });
};
